import { combineReducers } from 'redux';

import overviewRepositories, { DashboardOverviewState } from './overview';
import pullRequests, { DashboardPullRequestsState } from './pull-requests';
import repositories, { DashboardRepositoriesState } from './repositories';
import {
  owners,
  projects,
  workspaces,
  OwnersFilterState,
  ProjectsFilterState,
  WorkspacesFilterState,
} from './repository-filters';
import section, { DashboardSectionState } from './section';

export type DashboardState = {
  pullRequests: DashboardPullRequestsState;
  repositories: DashboardRepositoriesState;
  section: DashboardSectionState;
  repositoryFilters: {
    owners: OwnersFilterState;
    workspaces: WorkspacesFilterState;
    projects: ProjectsFilterState;
  };
  overviewRepositories: DashboardOverviewState;
};

export default combineReducers({
  pullRequests,
  section,
  repositories,
  repositoryFilters: combineReducers({
    owners,
    projects,
    workspaces,
  }),
  overviewRepositories,
});
